<div class="text-align-center">
  <h3 class="t-5@r color-jet mb-4">Are You Sure?</h3>
  <div class="t-8@r color-ash mb-6">
    @if (duration()) {
      Your voice message ({{ duration() | date: 'm:ss' }}) is ready to be sent.
    } @else {
      Your voice message is almost ready.
    }
  </div>
  <div class="t-8@r color-charcoal mb-6 font-weight-500">If you exit now, your recording will be deleted.</div>
  <div class="grid">
    <button
      class="g-col-6"
      sbButton
      [size]="'big'"
      [stretchable]="true"
      [variant]="'ghost-cloud'"
      (click)="confirmExit.emit()"
    >
      Exit
    </button>
    <button
      class="g-col-6"
      sbButton
      [disabled]="!conversationStore.voice()"
      [processing]="conversationStore.voiceUploadInProgress()"
      [size]="'big'"
      [stretchable]="true"
      [variant]="'fill-blue'"
      (click)="attemptToSendMessage()"
    >
      <sb-icon class="mr-1" [name]="'send'" />
      Send
    </button>
  </div>
</div>
